/**
 * Created by esenckewitch on 12.08.2026
 */

const CrossPromoCardHover = function (tile, controller, hoverScale) {
    cleverapps.UI.applyHover(tile, {
        interactiveScale: false,

        onMouseOver: function () {
            if (tile.stopListeners || !controller.isIntroReady()) {
                return;
            }
            tile.stopAllActions();
            tile.runAction(new cc.ScaleTo(CrossPromoCardHover.SCALE_DURATION, hoverScale));
        },

        onMouseOut: function () {
            if (tile.stopListeners) {
                return;
            }
            tile.stopAllActions();
            tile.runAction(new cc.ScaleTo(CrossPromoCardHover.SCALE_DURATION, 1));
        }
    });
};

CrossPromoCardHover.SCALE_DURATION = 0.09;

const CrossPromoFeaturedHover = function (controller, hoverScale, siblingScale) {
    this.controller = controller;
    this.hoverScale = hoverScale;
    this.siblingScale = siblingScale;
    this.tiles = [];
    this.hovered = null;
};

CrossPromoFeaturedHover.SCALE_DURATION = 0.09;

CrossPromoFeaturedHover.prototype.add = function (tile) {
    const self = this;

    this.tiles.push(tile);

    cleverapps.UI.applyHover(tile, {
        interactiveScale: false,

        onMouseOver: function () {
            if (!self.controller.isIntroReady()) {
                return;
            }
            self.hovered = tile;
            self.refresh();
        },

        onMouseOut: function () {
            if (self.hovered === tile) {
                self.hovered = null;
                self.refresh();
            }
        }
    });
};

CrossPromoFeaturedHover.prototype.refresh = function () {
    this.tiles.forEach((tile) => {
        if (tile.stopListeners) {
            return;
        }

        const isHovered = this.hovered === tile;

        let target = 1;
        if (isHovered) {
            target = this.hoverScale;
        } else if (this.hovered) {
            target = this.siblingScale;
        }

        tile.stopAllActions();
        tile.runAction(new cc.ScaleTo(CrossPromoFeaturedHover.SCALE_DURATION, target));
    });
};
